// LoginPage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      setIsLoading(false);

      if (data.success) {
         localStorage.setItem('userId', data.userId);
  localStorage.setItem('username', data.username);   // now works
  localStorage.setItem('email', data.email);
  localStorage.setItem('isParticipant', data.isParticipant);
  localStorage.setItem('programId', data.programId || '');
  localStorage.setItem('enrollmentRole', data.enrollmentRole || '');// <-- important!
localStorage.setItem('isManager', data.isManager);   // <-- NEW
        // Redirect to feedback type selection
        navigate("/select-feedback-type",{ replace: true });
        //window.location.reload(); 
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="form-container">
        {/* <img src="./UNextLogo2.png" alt="Logo" className="logo" /> */}
        <img src="./UNextMABLogo06.png" alt="Logo" className="logo" />
        <h2>Welcome</h2>
        {error && <p className="error">{error}</p>}

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="submit-button">
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <footer className="footer">
        <p>© {new Date().getFullYear()} UNext Learning Pvt Ltd</p>
      </footer>
    </div>
  );
};

export default LoginPage;
